<mat-card *ngIf="specialId=='' ">
	<mat-card-content>
		<div class="container1">
			<div slickContainer #slickController="slick" [slickConfig]="config">
				<ng-container *ngIf="slickController.initialize">
					<div slickItem *ngFor="let item of getSlickArray(slickArrayLength); let index = index">
						<img src="{{item.imgUrl}}" class="p-10 md-card-image img-box">
						<div class="{{item.cssClass}} slick-text">
							{{item.infoText}}
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</mat-card-content>
</mat-card>

<div *ngIf="specialId=='' " class="div-style-padding">
<!--
<div class="text-color-top1 header-4-center">
Better place to boost your skills
</div>
<div class="text-color-top3 header-4-center">
Better place to elevate your skills
</div>
<div class="text-color-top5 header-4-center">
Better place to estimate your skills
</div>
<p>
-->
<div class="div-style-justify">
	<div class="text-color-top2 header-3">
	Are you searching to elevate your skill(s) or want to help people to elevate there skill(s)!!!!!
	</div>
	<div class="text-color-top2 header-3">
	You reached to the right place.
	</div>
</div>
<div class="text-color-top8 margin-top">
	Study is not so easy without having right guidance. Right guidance can be provided by the skilled professionals.
	Only skilled professionals registers here who guides the needy persons on right path for there carrier growth.
	<div class="header-3-margin">How do you identify the best educator!!</div>
	<div class="header-2">Best educator will always have jolly & funny in nature. Similar mood they have to carry while sharing the information. It helps the candidate to mentally stable & enthusiast to learn.</div>
	<div class="header-2">Best educator makes the candidates hand dirty as much as possible which gives more thought in there mind</div>
	<div class="header-2">Best educator does not let there candidate goes on prediction, instead gives more realistic ways to think & proceed</div>
	<div class="header-2">Best educator does not bring the candidate mind with stress, which leads to go on wrong calculation even if he/she is able to make it right.</div>   
    <div class="header-2">We are still working hard to make things better and easy. </div>
</div>
</div>
<div *ngIf="extractedCompanyId > 0 " class="div-style-padding div-style-center ">
	<div class="div-style-justify text-color-top2 header-3-center">
		Welcome to ZED Professional Pre Exam Test
	</div>

	<div>&nbsp;</div>
	<div *ngIf="userLoggedIn == false" class="div-center">
		<button mat-raised-button color="primary" [routerLink]="['/signup', {'sid': specialId }]"> SignUp </button>

		&nbsp;&nbsp;&nbsp;&nbsp;
		<button mat-raised-button color="primary" routerLink="/login"> Login </button>
	</div>
	<div *ngIf="userLoggedIn == true" class="div-center">
		<button mat-raised-button color="primary" (click)="logout()"> LogOut </button>
	</div>
</div>